import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
// @mui
import { Button, Stack } from '@mui/material';
// hooks
import useLocales from '../hooks/useLocales';
// routes
import { PATH_PAGE } from '../routes/paths';
// ----------------------------------------------------------------------

ContactUs.propTypes = {
  sx: PropTypes.object,
};

export default function ContactUs({ sx = {} }) {
  const { translate } = useLocales();
  const navigate = useNavigate();
  return (
    <Stack spacing={3} sx={{ px: 4, pb: 3, mt: 10, width: 1, textAlign: 'center', display: 'block', ...sx }}>
      <Button variant="contained" onClick={() => navigate(PATH_PAGE.contact)}>
        {translate('contactus.contact_us')}
      </Button>
    </Stack>
  );
}

// export default function ContactUs({ sx = {} }) {
//   const { translate } = useLocales();
//   const [isOpenModal, setIsOpenModal] = useState(false);

//   const handleOpenModal = (value) => () => {
//     setIsOpenModal(value);
//   };

//   return (
//     <>
//       <Stack spacing={3} sx={{ px: 4, pb: 3, mt: 10, width: 1, textAlign: 'center', display: 'block', ...sx }}>
//         <Button variant="contained" onClick={handleOpenModal(true)}>
//           {translate('contactus.contact_us')}
//         </Button>
//       </Stack>

//       <Dialog onClose={handleOpenModal(false)} open={isOpenModal}>
//         <DialogTitle>{translate('contactus.dialog.title')}</DialogTitle>
//         <Box p={4} maxWidth={{ xs: '100%', md: '420px' }}>
//           <Typography component={'div'}>
//             {translate('contactus.dialog.description')}
//             <Typography component={'span'} sx={{ fontWeight: 500 }}>
//               {'0911091087 (Mr. Luân)'}
//             </Typography>
//           </Typography>
//         </Box>
//       </Dialog>
//     </>
//   );
// }
